import { useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BreadcrumbItem {
  name: string;
  path: string;
}

export default function Breadcrumb() {
  const { t } = useTranslation();
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const breadcrumbMap: Record<string, string> = {
    category: '赛事资讯',
    article: '文章详情',
    about: '关于我们',
  };

  const items: BreadcrumbItem[] = [{ name: t('breadcrumb.home', '首页'), path: '/' }];

  if (pathnames.length > 0) {
    const currentPath = pathnames[0];
    if (breadcrumbMap[currentPath]) {
      items.push({
        name: breadcrumbMap[currentPath],
        path: `/${currentPath}`,
      });
    }
    if (pathnames.length > 1) {
      items.push({
        name: decodeURIComponent(pathnames[1]),
        path: location.pathname,
      });
    }
  }

  if (items.length <= 1) return null;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `https://damanjuapp.com${item.path}`,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="w-full bg-background-100 border-b border-background-200">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
          <ol className="flex flex-wrap items-center gap-1 text-sm">
            {items.map((item, index) => (
              <li key={item.path} className="flex items-center gap-1">
                {index > 0 && (
                  <i className="ri-arrow-right-s-line text-foreground-400 w-4 h-4 flex items-center justify-center"></i>
                )}
                {index === items.length - 1 ? (
                  <span className="text-foreground-600 font-medium">{item.name}</span>
                ) : (
                  <Link
                    to={item.path}
                    className="text-foreground-400 hover:text-primary-500 transition-colors duration-200"
                  >
                    {item.name}
                  </Link>
                )}
              </li>
            ))}
          </ol>
        </div>
      </nav>
    </>
  );
}